export default "__VITE_ASSET__b88e8fe4__"